// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import { motion } from "framer-motion"; // Importing framer-motion for animations

import FirstGen from "../homepage_images/hero-image/cloth.webp"; // Importing image for the hero section
import LongRcBasket from "../homepage_images/hero-image/long_reciept_basket.png"; // Importing another image for the hero section
import PhoneReciept from "../homepage_images/hero-image/phoneReciepts.png"; // Importing another image for the hero section
import UNICLOUD from "../homepage_images/hero-image/unicloud01.png"; // Importing another image for the hero section

import posbag from "../homepage_images/hero-image/posbag.png"; // Importing another image for the hero section
import cattom from "../homepage_images/hero-image/cattom.webp"; // Importing another image for the hero section

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade"; // ✅ Important for fade to work

export default function HeroSwiper() {
  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, Pagination, EffectFade]}
      effect="fade"
      fadeEffect={{ crossFade: true }}
      speed={1500} // 👈 ADDED: controls how long the fade lasts
    >
      <SwiperSlide>
        <figure>
          <img src={PhoneReciept} alt="Hero illustration" />
        </figure>
      </SwiperSlide>
      <SwiperSlide>
        <figure>
          <img src={UNICLOUD} alt="Hero illustration" />
        </figure>
      </SwiperSlide>
      <SwiperSlide>
        <figure>
          <img src={LongRcBasket} alt="Hero illustration" />
        </figure>
      </SwiperSlide>
      <SwiperSlide>
        <figure>
          <img src={posbag} alt="Hero illustration" />
        </figure>
      </SwiperSlide>
      <SwiperSlide>
        <figure>
          <img src={cattom} alt="Hero illustration" />
        </figure>
      </SwiperSlide>
    </Swiper>
  );
}
